const handleScroll = () => {
  const anchors = document.querySelectorAll(
    'a[href^="#"]:not(a[href="#modal"])'
  );

  anchors.forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      e.preventDefault();

      const target = e.target;

      const scrollTargetID = target.href.split('#')[1];
      const scrollTarget = document.getElementById(scrollTargetID);

      if (scrollTarget === null) {
        return window.scroll(0, 0);
      }

      const scrollTargetHidden =
        !scrollTarget.classList.contains('aos-animate');
      const { y } = scrollTarget.getBoundingClientRect();
      const scroll = window.scrollY;

      const headerHeight = document.querySelector('header')?.clientHeight ?? 0;

      scrollTargetHidden
        ? window.scroll(0, `${scroll + y - headerHeight - 100} `)
        : window.scroll(0, `${scroll + y - headerHeight}`);
    });
  });
};

export default handleScroll;
